import { render, staticRenderFns } from "./create-password.vue?vue&type=template&id=8762481c&scoped=true&"
import script from "./create-password.vue?vue&type=script&lang=js&"
export * from "./create-password.vue?vue&type=script&lang=js&"
import style0 from "@/assets/auth-screen.scss?vue&type=style&index=0&id=8762481c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8762481c",
  null
  
)

component.options.__file = "create-password.vue"
export default component.exports